import React from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  DatePicker,
  Tag,
  Space,
  Progress,
  Select,
  Alert,
  Switch,
  Spin,
  Menu,
  message,
} from "antd";
import {
  UploadOutlined,
  FileDoneOutlined,
  DeleteFilled,
  IdcardOutlined,
  UserOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { apiCallPost, apiCallPostProgress, niceDateTime } from "../fns/util";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import RegistrationPage from "./RegistrationPage";

class Profile extends React.Component {
  state = {
    name: "",
    dob: "",
    sex: "",
    mobile: "",
    isOSWBMember: false,
    oswbMembershipId: null,
    oswbMembershipPlanName: null,
    ageProofFileURL: "",
    ageProofFileKey: "",
    ageProofFileName: null,
    isUploading: false,
    uploadProgress: 0,
    isSubmitting: false,
    isAdmin: false,
    addAccompanyingName: "",
    addAccompanyingEmail: "",
    addAccompanyingMobile: "",
    isAddingAccompanyingDelegate: false,
    linkedDelegate: null,
    isLoadingLinkedDelegate: false,
    isRemovingAccompanyingDelegate: false,
    navOptions: [
      {
        label: "Profile",
        key: "PROFILE",
        icon: <UserOutlined />,
      },
    ],
    currentNav: "PROFILE",
  };
  billingPersonaList = [
    "NEW_LIFE_MEMBER",
    "LIFE_MEMBER",
    "LIFE_MEMBER_ABOVE_75",
    "PGT_MEMBER",
    "PGT_MEMBER_NEW",
    "PGT_NON_MEMBER",
    "NON_MEMBER",
    "SPOUSE",
    "SPOUSE_ABOVE_75",
    "PAST_FUNCTIONARY",
    "PAST_PRESIDENT",
    "GUEST_FACULTY",
  ];
  componentDidMount() {
    if (this.props.mode === "CREATE") {
      this.setState({
        name: this.props.preloadedData.full_name || "",
        dob: this.props.preloadedData.dob || "",
        sex: this.props.preloadedData.sex || "",
        email: this.props.context.userEmail || "",
        mobile: this.props.preloadedData.mobile_number || "",
        isOSWBMember: this.props.preloadedData.membership_id ? true : false,
        oswbMembershipId: this.props.preloadedData.membership_id || "",
        oswbMembershipPlanName:
          this.props.preloadedData.membership_plan_name || "",
        ageProofFileURL: "",
        ageProofFileKey: "",
        ageProofFileName: null,
        isUploading: false,
        uploadProgress: 0,
        billingPersona: this.props.preloadedData.billingPersona || "",
      });
    } else if (this.props.mode === "EDIT") {
      let {
        name,
        email,
        dob,
        sex,
        mobile,
        isOSWBMember,
        oswbMembershipId,
        oswbMembershipPlanName,
        ageProofFileKey,
        isAdmin,
        billingPersona,
      } = this.props.preloadedData;
      this.setState(
        {
          name,
          dob,
          email,
          sex,
          mobile,
          isOSWBMember,
          oswbMembershipId,
          oswbMembershipPlanName,
          ageProofFileKey,
          isAdmin,
          billingPersona,
          navOptions: [
            ...this.state.navOptions,
            {
              label: "Registration",
              key: "REGISTRATION",
              icon: <IdcardOutlined />,
            },
          ],
          currentNav: this.props.isRegistering ? "REGISTRATION" : "PROFILE",
        },
        () => {
          this.handleDownload(this.state.ageProofFileKey);
          if (
            this.props.preloadedData.isMainDelegate &&
            this.props.preloadedData.linkedDelegate
          ) {
            this.getLinkedDelegateDetails();
          }
        }
      );
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  updateChange = async (e) => {
    if (this.props.mode === "CREATE") {
      return;
    }
    try {
      message.loading(`Updating ${e.target.name}...`);

      let { name, value } = e.target;
      this.setState({ isSubmitting: true });
      let token = await this.props.context.provideToken();
      await apiCallPost(token, "/conference2023/editDetails", {
        key: name,
        value,
        targetId: this.props.preloadedData._id,
      });
      this.setState({
        [name]: name === "mobile" ? value.substr(3) : value,
        isSubmitting: false,
      });
      message.success("Updated successfully.");
    } catch (err) {
      message.error("Error updating.");
      this.setState({ isSubmitting: false });
      console.log(err);
    }
  };
  getLinkedDelegateDetails = async () => {
    this.setState({
      isLoadingLinkedDelegate: true,
    });
    let token = await this.props.context.provideToken();
    try {
      let res = await apiCallPost(
        token,
        "/conference2023/getLinkedDelegateDetails",
        {
          targetId: this.props.preloadedData._id,
        }
      );
      if (res && res.linked && res.linked._id) {
        this.setState({
          linkedDelegate: res.linked,
          isLoadingLinkedDelegate: false,
          addAccompanyingEmail: res.linked.email,
          addAccompanyingMobile: res.linked.mobile,
          addAccompanyingName: res.linked.name,
        });
      } else {
        this.setState({
          isLoadingLinkedDelegate: false,
        });
      }
    } catch (err) {
      this.setState({ isLoadingLinkedDelegate: false });
      console.log(err);
      message.error("Error fetching linked delegate details.");
    }
  };
  handleDateChange = (date, dateString) => {
    // Check if date is not null before setting the state
    if (date) {
      this.setState({ dob: dayjs(dateString, "DD-MM-YYYY").toDate() });
    }
    if (this.props.mode === "EDIT") {
      let e = {
        target: {
          name: "dob",
          value: dayjs(dateString, "DD-MM-YYYY").toDate(),
        },
      };
      this.updateChange(e);
    }
  };
  handleSubmit = async () => {
    let payload = {
      name: this.state.name,
      mobile: this.state.mobile,
      isOSWBMember: this.state.isOSWBMember,
      oswbMembershipId: this.state.oswbMembershipId,
      oswbMembershipPlanName: this.state.oswbMembershipPlanName,
      sex: this.state.sex || undefined,
      dob: this.state.dob || undefined,
      ageProofFileKey: this.state.ageProofFileKey || undefined,
    };

    this.setState({ isSubmitting: true });
    try {
      let token = await this.props.context.provideToken();
      let res = await apiCallPost(
        token,
        "/conference2023/createDelegate",
        payload
      );

      if (
        res.message === "Delegate registered successfully" &&
        res.delegate &&
        res.delegate._id
      ) {
        this.setState({ isSubmitting: false });
        message.success("Profile updated successfully.");
        this.props.onUpdate(res.delegate);
      }
    } catch (err) {
      message.error("Error updating profile.");
      this.setState({ isSubmitting: false });
    }
  };
  validateOrSubmit = () => {
    if (this.props.mode === "EDIT") {
      return;
    }
    if (this.state.mobile) {
      return (
        <Button
          type="primary"
          onClick={this.handleSubmit}
          disabled={this.state.isSubmitting}
          loading={this.state.isSubmitting}
        >
          Proceed
        </Button>
      );
    } else {
      return (
        <Alert
          message="Error"
          description="Please enter a valid mobile number to proceed."
          type="error"
          showIcon
        />
      );
    }
  };
  handleDownload = async (key) => {
    if (!key) {
      return;
    }
    let token = await this.props.context.provideToken();
    let resDownloadKey = await apiCallPost(
      token,
      "/conference2023/downloadFile",
      {
        keyName: key,
      }
    );
    this.setState({
      isUploading: false,
      uploadProgress: 0,
      ageProofFileName: null,
      ageProofFileURL: resDownloadKey.url,
    });
  };
  handleFileUpload = async (file) => {
    let token = await this.props.context.provideToken();
    this.setState({
      ageProofFileName: file.name,
      isUploading: true,
      isSubmitting: true,
    });
    const formData = new FormData();
    formData.append("file", file);
    formData.append("purpose", "AGE_PROOF");

    let res = await apiCallPostProgress(
      token,
      `/conference2023/uploadFile`,
      formData,
      (done, total) => {
        this.setState({ uploadProgress: ((done / total) * 100).toFixed(1) });
      }
    );

    this.setState(
      {
        ageProofFileKey: res.keyName,
        isSubmitting: false,
      },
      () => {
        if (this.props.mode === "EDIT") {
          let e = {
            target: {
              name: "ageProofFileKey",
              value: res.keyName,
            },
          };
          this.updateChange(e);
        }
        this.handleDownload(res.keyName);
      }
    );

    return false;
  };
  handleAddAccompanyingDelegate = async () => {
    try {
      this.setState({ isAddingAccompanyingDelegate: true });
      let token = await this.props.context.provideToken();
      let res = await apiCallPost(
        token,
        "/conference2023/inviteAccompanyingDelegate",
        {
          name: this.state.addAccompanyingName,
          email: this.state.addAccompanyingEmail,
          mobile: this.state.addAccompanyingMobile,
          targetId: this.props.preloadedData._id,
        }
      );
      this.props.onDelegateUpdate(res.delegate);
      this.setState({ isAddingAccompanyingDelegate: false }, () =>
        this.getLinkedDelegateDetails()
      );
    } catch (err) {
      message.error("Error adding accompanying delegate.");
      this.setState({ isAddingAccompanyingDelegate: false });
    }
  };
  handleRemoveAccompanyingDelegate = async () => {
    try {
      this.setState({ isRemovingAccompanyingDelegate: true });
      let token = await this.props.context.provideToken();
      let res = await apiCallPost(
        token,
        "/conference2023/delinkAccompanyingDelegate",
        {
          targetId: this.props.preloadedData._id,
        }
      );
      this.props.onDelegateUpdate(res.delegate);
      this.setState({
        isRemovingAccompanyingDelegate: false,
        linkedDelegate: null,
        addAccompanyingEmail: "",
        addAccompanyingMobile: "",
        addAccompanyingName: "",
      });
    } catch (err) {
      message.error("Error removing accompanying delegate.");
      this.setState({ isRemovingAccompanyingDelegate: false });
    }
  };
  renderAccompanyingDelegateForm = () => {
    if (!this.props.preloadedData.isOSWBMember) {
      return null;
    }
    if (this.props.mode === "CREATE") {
      return null;
    }

    if (
      this.props.preloadedData.isMainDelegate &&
      !this.props.preloadedData.linkedDelegate &&
      !this.props.preloadedData.isRegistered
    ) {
      return (
        <Space direction="vertical" size="small">
          <Tag color="orange">Accompanying Delegate Details</Tag>
          <p className="small_text">
            You can bring along your spouse as your accompanying delegate.
            Please enter their details below.
          </p>{" "}
          <Form.Item
            label="Name"
            rules={[
              {
                required: true,
                message: "Please input the name!",
              },
            ]}
          >
            <Input
              placeholder="Name"
              value={this.state.addAccompanyingName}
              onChange={(e) =>
                this.setState({ addAccompanyingName: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item
            label="Email"
            rules={[
              {
                required: true,
                message: "Please input the name!",
              },
            ]}
          >
            <Input
              placeholder="Email"
              value={this.state.addAccompanyingEmail}
              onChange={(e) =>
                this.setState({ addAccompanyingEmail: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item
            label="Phone"
            rules={[
              {
                required: true,
                message: "Please input the phone number!",
              },
            ]}
          >
            <PhoneInput
              name="Phone"
              defaultCountry="IN"
              placeholder="Phone"
              value={this.state.addAccompanyingMobile}
              onChange={(e) => {
                this.setState({ addAccompanyingMobile: e });
              }}
            />
          </Form.Item>
          <Button
            type="primary"
            onClick={this.handleAddAccompanyingDelegate}
            disabled={
              !this.state.addAccompanyingEmail ||
              !this.state.addAccompanyingMobile ||
              !this.state.addAccompanyingName
            }
            loading={this.state.isAddingAccompanyingDelegate}
          >
            Add Accompanying Delegate
          </Button>
        </Space>
      );
    }

    if (
      this.props.preloadedData.isMainDelegate &&
      this.props.preloadedData.linkedDelegate
    ) {
      if (this.state.isLoadingLinkedDelegate) {
        return (
          <Space direction="vertical" size="small">
            <Tag color="orange">Accompanying Delegate Details</Tag>
            <Spin />
          </Space>
        );
      }
      return (
        <Space direction="vertical" size="small">
          <Tag color="orange">Accompanying Delegate Details</Tag>
          <>
            <b>Name:</b>
            {this.state.addAccompanyingName}
          </>
          <>
            <b>Email: </b>
            {this.state.addAccompanyingEmail}
          </>
          <>
            <b>Mobile: </b>
            {this.state.addAccompanyingMobile}
          </>
          {!this.props.preloadedData.isRegistered && (
            <>
              <Button
                danger
                onClick={this.handleRemoveAccompanyingDelegate}
                loading={this.state.isRemovingAccompanyingDelegate}
              >
                Remove Accompanying Delegate
              </Button>
            </>
          )}
        </Space>
      );
    }

    if (!this.props.preloadedData.isMainDelegate) {
      return null;
    }
  };
  renderProfileForm = () => {
    return (
      <div style={{ marginTop: "20px" }}>
        <Form disabled={this.state.isSubmitting}>
          <Space direction="vertical" size="middle">
            {this.props.user === "NON_MEMBER_SIGN_UP" && (
              <Alert
                message="You are signing up as a non-member. If you are a registered member of OSWB, this means that you may have signed in with an email that's not your registered email. In such a scenario, please log out from the bottom-left corner of this page on the side bar, and sign in with your registered email."
                type="error"
              />
            )}
            <Space direction="vertical" size="small">
              <Tag color="blue">Basic Details</Tag>
              <p>
                <a
                  href={`/b/${this.props.preloadedData._id}/${this.props.preloadedData.name}}/FACULTY_BADGE`}
                  target="_blank"
                  rel="noreferrer"
                >
                  PRINT BADGE FACULTY
                </a>
              </p>
              <p>
                <a
                  href={`/b/${this.props.preloadedData._id}/${
                    this.props.preloadedData.name
                  }}/${this.props.preloadedData.badgeSpec || "DELEGATE_BADGE"}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  PRINT BADGE badgeSpace
                </a>
              </p>
              <p>
                <a
                  href={`/c/${this.props.preloadedData._id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  VIEW COMMITMENTS
                </a>
              </p>
              <p>
                Kit Regn: {!!this.props.preloadedData.kitHandover} @{" "}
                {niceDateTime(this.props.preloadedData.kitHandoverTime)}
              </p>
              <p>
                Meal Specs:{" "}
                {(this.props.preloadedData.mealSpecs || []).join(", ")}
              </p>

              <p className="small_text">
                To edit name or email, please use the{" "}
                <a
                  href="https://members.oswb.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  membership portal
                </a>
                .
              </p>
              <Form.Item label="Name">
                <Input
                  disabled={
                    !(
                      this.props.isAdmin ||
                      this.props.user === "NON_MEMBER_SIGN_UP"
                    )
                  }
                  value={this.state.name}
                  name="name"
                  onChange={this.handleChange}
                  onBlur={this.updateChange}
                />
              </Form.Item>
              <Form.Item label="Email">
                <Input disabled value={this.state.email} name="email" />
              </Form.Item>
              <Form.Item label="Mobile">
                <PhoneInput
                  disabled={this.state.isSubmitting}
                  value={this.state.mobile}
                  name="mobile"
                  defaultCountry="IN"
                  onChange={(val) => {
                    this.setState({ mobile: val });
                  }}
                  onBlur={() => {
                    this.updateChange({
                      target: {
                        name: "mobile",
                        value: this.state.mobile,
                      },
                    });
                  }}
                  placeholder="Phone"
                />
              </Form.Item>
            </Space>
            {this.props.preloadedData.isOSWBMember && (
              <Space direction="vertical" size="small">
                <Tag color="magenta">Membership Details</Tag>
                <p className="small_text">
                  If you notice any errors here, contact us immediately. You can
                  email us at support@0oswb.org, or call us at: +919836340743.
                </p>

                <Space.Compact block>
                  {" "}
                  <Tag>Membership Type:</Tag>
                  <Tag color="magenta">{this.state.oswbMembershipPlanName}</Tag>
                </Space.Compact>
                <Space.Compact block>
                  {" "}
                  <Tag>Membership Number:</Tag>
                  <Tag color="magenta">{this.state.oswbMembershipId}</Tag>
                </Space.Compact>
                <br />
              </Space>
            )}
            <Space direction="vertical" size="small">
              <Tag color="orange">Age & Sex Details</Tag>
              <p className="small_text">
                It is not mandatory to enter your date of birth or submit an age
                proof. However, age proof and date of birth are required if you
                are eligible for a specific rate (such as a Senior Member rate),
                or applying for certain award tracks (such as Dr K P Roy
                Competition for Papers). This can also be used for internal
                analytics.
              </p>{" "}
              <Form.Item label="Date of Birth">
                <DatePicker
                  allowClear
                  disabled={this.state.isSubmitting}
                  showToday={false}
                  format="DD-MM-YYYY"
                  value={this.state.dob ? dayjs(this.state.dob) : null}
                  onChange={this.handleDateChange}
                />
              </Form.Item>
              <Form.Item label="Age Proof">
                {this.state.ageProofFileKey ? (
                  <Space.Compact align="center">
                    <Button
                      icon={<FileDoneOutlined />}
                      href={this.state.ageProofFileURL}
                      target="_blank"
                      disabled={this.state.isSubmitting}
                    >
                      View Uploaded File
                    </Button>
                    <Button
                      danger
                      disabled={this.state.isSubmitting}
                      onClick={() =>
                        this.setState(
                          {
                            ageProofFileKey: "",
                          },
                          () => {
                            if (this.props.mode === "EDIT") {
                              let e = {
                                target: {
                                  name: "ageProofFileKey",
                                  value: "",
                                },
                              };
                              this.updateChange(e);
                            }
                          }
                        )
                      }
                      icon={<DeleteFilled />}
                    ></Button>
                  </Space.Compact>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      flexWrap: "nowrap",
                    }}
                  >
                    <Upload
                      beforeUpload={this.handleFileUpload}
                      maxCount={1}
                      showUploadList={false}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        loading={this.state.isUploading}
                        disabled={
                          this.state.isUploading || this.state.isSubmitting
                        }
                      >
                        {this.state.ageProofFileName
                          ? `Uploading ${this.state.ageProofFileName}`
                          : "Choose File"}
                      </Button>
                    </Upload>{" "}
                    {this.state.isUploading && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          marginLeft: "5px",
                        }}
                      >
                        <Progress
                          percent={this.state.uploadProgress}
                          type="circle"
                          size={40}
                        />
                      </div>
                    )}
                  </div>
                )}
              </Form.Item>
              <Form.Item label="Sex">
                <Select
                  allowClear
                  disabled={this.state.isSubmitting}
                  value={this.state.sex}
                  name="sex"
                  onChange={(value) =>
                    this.setState({ sex: value }, () => {
                      if (this.props.mode === "EDIT") {
                        let e = {
                          target: {
                            name: "sex",
                            value,
                          },
                        };
                        this.updateChange(e);
                      }
                    })
                  }
                >
                  <Select.Option value="male">Male</Select.Option>
                  <Select.Option value="female">Female</Select.Option>
                  <Select.Option value="other">Other</Select.Option>
                </Select>
              </Form.Item>
            </Space>
            {this.props.isAdmin && (
              <Space direction="vertical" size="small">
                <Tag color="red">Admin Area</Tag>
                <p className="small_text">Administrative Controls</p>
                <Form.Item label="Is this user an admin?">
                  <Switch
                    checked={this.state.isAdmin}
                    onChange={(value) => {
                      // check target
                      this.setState({ isAdmin: value }, () => {
                        if (this.props.mode === "EDIT") {
                          let e = {
                            target: {
                              name: "isAdmin",
                              value,
                            },
                          };
                          this.updateChange(e);
                        }
                      });
                    }}
                  />
                </Form.Item>
                <Form.Item label="Billing Persona">
                  <Select
                    disabled={this.state.isSubmitting}
                    value={this.state.billingPersona}
                    name="billingPersona"
                    onChange={(value) =>
                      this.setState({ billingPersona: value }, () => {
                        if (this.props.mode === "EDIT") {
                          let e = {
                            target: {
                              name: "billingPersona",
                              value,
                            },
                          };
                          this.updateChange(e);
                        }
                      })
                    }
                  >
                    {this.billingPersonaList.map((item) => {
                      return <Select.Option value={item}>{item}</Select.Option>;
                    })}
                  </Select>
                </Form.Item>
              </Space>
            )}
          </Space>
        </Form>
        {this.validateOrSubmit()} <br /> {this.renderAccompanyingDelegateForm()}
        <br />
      </div>
    );
  };
  renderRegistration = () => {
    return (
      <div style={{ marginTop: "20px" }}>
        <RegistrationPage
          loggedInUser={this.props.loggedInUser}
          isAdmin={this.props.isAdmin}
          context={this.props.context}
          primaryDelegate={this.props.preloadedData}
          linkedDelegate={this.state.linkedDelegate}
          onDelegateUpdate={this.props.onDelegateUpdate}
        />
      </div>
    );
  };
  render() {
    return (
      <div style={{ padding: "20px" }}>
        <Menu
          mode="horizontal"
          items={this.state.navOptions}
          onClick={(e) => {
            this.setState({
              currentNav: e.key,
            });
          }}
        />
        {this.state.currentNav === "PROFILE" && this.renderProfileForm()}
        {this.state.currentNav === "REGISTRATION" && this.renderRegistration()}
      </div>
    );
  }
}

export default Profile;
